import type { Appointment, WorkingOnGroup } from "../api.ts";
import { captionStyle, colors } from "../theme.ts";
import { GlassCard } from "./glass.tsx";
import { containerLine } from "./ContainerSheet.tsx";

/** Today's appointments: the time, then what it is. Tapping one opens the task. */
export function Appointments({ items, onOpen }: { items: Appointment[]; onOpen: (id: string) => void }) {
  if (!items.length) return null;
  return (
    <GlassCard padding="12px 16px 2px" style={{ marginBottom: 16 }}>
      <div style={captionStyle}>Today</div>
      {items.map((a) => (
        <div
          key={a.id} role="button" tabIndex={0}
          onClick={() => onOpen(a.id)} onKeyDown={(e) => { if (e.key === "Enter") onOpen(a.id); }}
          style={{
            display: "grid", gridTemplateColumns: "48px 1fr", gap: 12, alignItems: "baseline",
            padding: "12px 0", borderBottom: `1px solid ${colors.hair}`, cursor: "pointer",
          }}
        >
          <span style={{ fontSize: 15, color: colors.ink, fontVariantNumeric: "tabular-nums" }}>{a.time}</span>
          <div style={{ minWidth: 0, lineHeight: 1.3 }}>
            <div style={{ fontSize: 15, color: a.state === "done" ? colors.ink2 : colors.ink }}>{a.title}</div>
            {(a.container_key ?? a.area_name) && (
              <div style={{ fontSize: 12.5, color: colors.ink2, marginTop: 2 }}>{a.container_key ?? a.area_name}</div>
            )}
          </div>
        </div>
      ))}
    </GlassCard>
  );
}

/**
 * The working-on strip: one line per active or waiting container, with its
 * kind, status line and what it waits on. Listed, never counted: no tallies,
 * no progress, nothing about how long anything has taken.
 */
export function WorkingOnStrip({ groups, onOpen }: { groups: WorkingOnGroup[]; onOpen: (key: string) => void }) {
  const containers = groups.flatMap((g) => g.containers);
  if (!containers.length) return null;
  return (
    <GlassCard padding="12px 16px 2px" style={{ marginTop: 16 }}>
      <div style={captionStyle}>Working on</div>
      {containers.map((c) => (
        <div
          key={c.key} role="button" tabIndex={0}
          onClick={() => onOpen(c.key)} onKeyDown={(e) => { if (e.key === "Enter") onOpen(c.key); }}
          style={{ padding: "12px 0", borderBottom: `1px solid ${colors.hair}`, cursor: "pointer", lineHeight: 1.3 }}
        >
          <div style={{ fontSize: 15, color: c.lifecycle === "waiting" ? colors.ink2 : colors.ink }}>{c.name}</div>
          <div style={{ fontSize: 12.5, color: colors.ink2, marginTop: 2 }}>{containerLine(c)}</div>
        </div>
      ))}
    </GlassCard>
  );
}
